import { REPLICATION_SIZE } from '../../../utils/constants';
import { auditFields, buildReplication } from '../utils';

/**
 * Pull builder for equipment data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listEquipments(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        name
        serialNumber
        manufacturerDate
        expiryDate
        maintenanceSchedule
        isFunctional

        facility { id name address }
        item {
          id
          name
          manufacturer
          model

          category { id name }
        }

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Synchronize equipment data with GraphQL endpoint
 */
export const syncEquipment = (...args) => {
  return buildReplication(
    ...args,
    'equipment',
    { pullBuilder, pullQuery: 'listEquipments' }
  );
};
